import qs from 'qs'

import { authorizedEdgeFetch } from 'app/axios/edge'

export interface domainAuditLogsQueryParameters {
  page: number
  count: number
}

export function getDomainAuditLogs(
  domainId: string,
  queryParameters: domainAuditLogsQueryParameters
) {
  const query = qs.stringify(queryParameters)
  return authorizedEdgeFetch.get(`/rms/domains/${domainId}/logs?${query}`)
}
